'use strict';

angular.module('programme')

.component('articleNav', {
    controller: 'ArticleNavCtrl',
    controllerAs: '$ctrl',
    templateUrl: 'modules/programme/components/articleNav/articleNav.html',
    bindings: {
        programme: '<',
        article: '<',
        articles: '<',
        categories: '<',
    }
})

.controller('ArticleNavCtrl', function ($scope, $state)
{
    this.$onInit = function () {
        this.category = this.article ? this.article.category : null;
    };

    this.getProgrammeLayout = function() {
        return this.programme.layout;
    };

    this.hasSectionPrev = function()
    {
        var index = this.categories.indexOf(this.category);

        if (this.categories[index - 1]) {
            return true;
        }

        return false;
    };

    this.hasSectionNext = function()
    {
        var index = this.categories.indexOf(this.category);

        if (this.categories[index + 1]) {
            return true;
        }

        return false;
    };

    this.goSectionPrev = function()
    {
        var index = this.categories.indexOf(this.category);
        var next = this.categories[index - 1];
        $state.go('programme.category', {categorySlug: next.slug});
    };

    this.goSectionNext = function()
    {
        var index = this.categories.indexOf(this.category);
        var next = this.categories[index + 1];

        $state.go('programme.category', {categorySlug: next.slug});
    };

    this.title = function(type, direction)
    {
        var target = type === 'article' ? this.articles : this.categories;
        var source = type === 'article' ? this.article : this.category;
        var index = target.indexOf(source);
        const newIndex = direction === 'prev' ? index - 1 : index + 1;
        return target[newIndex] ? target[newIndex].title : '';
    };

    this.hasPrev = function()
    {
        var index = this.articles.indexOf(this.article);

        if (this.articles[index - 1]) {
            var pages = this.articles[index - 1].getPages();
            if (pages.length > 0) {
                return true;
            }
        }

        return false;
    };

    this.hasNext = function()
    {
        var index = this.articles.indexOf(this.article);

        if (this.articles[index + 1]) {
            var pages = this.articles[index + 1].getPages();
            if (pages.length > 0) {
                return true;
            }
        }

        return false;
    };

    this.goPrev = function()
    {
        var index = this.articles.indexOf(this.article);
        var next = this.articles[index - 1];

        $state.go('programme.category.article.page', {articleSlug: next.slug, pageNum: "1"});
    };

    this.goNext = function()
    {
        var index = this.articles.indexOf(this.article);
        var next = this.articles[index + 1];
        $state.go('programme.category.article.page', {articleSlug: next.slug, pageNum: "1"});
    };

});
